// src/lib/access/paidJourneyAccess.js



import { supabase } from "../../supabaseClient";



import {
  getMySubscriptionStatus,
} from "../payments/subscriptions";

import {
  getReferralMonthAccess,
} from "../referrals/referrals";



import {

  getPartnerSponsoredPaidJourneyResult,

} from "./partnerSponsoredAccess";








const ACCESS_CACHE_PREFIX =

  "gwin_paid_journey_access_session_v3";





const DENIED_CACHE_MAX_AGE_MS =

  60 * 1000;



const PARTNER_SPONSORED_CACHE_MAX_AGE_MS =

  60 * 1000;





/* -------------------------------------------------------------------------- */

/* Number helpers                                                             */

/* -------------------------------------------------------------------------- */



function toNumber(value) {

  if (

    value == null ||

    value === ""

  ) {

    return null;

  }



  const match =

    String(value).match(

      /(\d+)/

    );



  if (!match?.[1]) {

    return null;

  }



  const parsed =

    Number(

      match[1]

    );



  return Number.isFinite(

    parsed

  )

    ? parsed

    : null;

}








/* -------------------------------------------------------------------------- */

/* Session cache                                                              */

/* -------------------------------------------------------------------------- */



function makeAccessCacheKey(

  userId

) {

  if (!userId) {

    return null;

  }



  return `${ACCESS_CACHE_PREFIX}:${userId}`;

}





function getAccessHardExpiryMs(

  access

) {

  if (

    !access ||

    typeof access !==

      "object"

  ) {

    return null;

  }





  /*

   * Partner-sponsored access can have a real

   * expiry boundary based on the cohort end date.

   *

   * Referral and once-off access do not use this

   * field, so their existing session-cache

   * behaviour remains unchanged.

   */

  const rawExpiry =

    access.cacheExpiresAt ||

    access.cache_expires_at ||

    null;





  if (!rawExpiry) {

    return null;

  }





  const parsedExpiry =

    Date.parse(

      rawExpiry

    );





  return Number.isFinite(

    parsedExpiry

  )

    ? parsedExpiry

    : null;

}





function readPaidJourneyAccessSessionCache(

  userId

) {

  try {

    if (

      typeof window ===

      "undefined"

    ) {

      return null;

    }





    const cacheKey =

      makeAccessCacheKey(

        userId

      );





    if (!cacheKey) {

      return null;

    }





    const raw =

      window.sessionStorage.getItem(

        cacheKey

      );





    if (!raw) {

      return null;

    }





    const parsed =

      JSON.parse(

        raw

      );





    const access =

      parsed?.access;





    const savedAt =

      Number(

        parsed?.savedAt ||

          0

      );





    if (

      !access ||

      typeof access !==

        "object" ||

      !savedAt

    ) {

      window.sessionStorage.removeItem(

        cacheKey

      );



      return null;

    }





    /*

     * --------------------------------------------------------

     * Partner-sponsored hard expiry

     * --------------------------------------------------------

     *

     * A sponsored-access result must not survive beyond

     * the effective cohort sponsorship boundary.

     *

     * Example:

     *

     * cohort ends 30 Sep

     * → access remains valid throughout 30 Sep

     * → cacheExpiresAt points to the next boundary

     * → cached Partner access disappears automatically

     */

    const hardExpiryMs =

      getAccessHardExpiryMs(

        access

      );





    if (

      hardExpiryMs !== null &&

      Date.now() >=

        hardExpiryMs

    ) {

      window.sessionStorage.removeItem(

        cacheKey

      );



      return null;

    }



        /*

     * --------------------------------------------------------

     * Partner-sponsored revalidation

     * --------------------------------------------------------

     *

     * Cohort end_date gives us the absolute hard boundary,

     * but sponsorship can also be revoked earlier when:

     *

     * - the Partner Organisation is suspended

     * - the cohort is archived/completed

     * - the learner is removed

     * - the accepted invitation becomes invalid

     *

     * Re-check successful Partner sponsorship periodically

     * instead of trusting one result for the entire session.

     */

    if (

      access.allowed === true &&

      access.reason ===

        "partner_sponsored_access" &&

      Date.now() -

        savedAt >=

        PARTNER_SPONSORED_CACHE_MAX_AGE_MS

    ) {

      window.sessionStorage.removeItem(

        cacheKey

      );



      return null;

    }





    /*

     * --------------------------------------------------------

     * Denied result expiry

     * --------------------------------------------------------

     *

     * Denied access expires quickly so a newly completed

     * payment, referral unlock or Partner sponsorship can

     * be discovered without requiring a new browser session.

     */

    if (

      access.allowed !==

        true &&

      Date.now() -

        savedAt >

        DENIED_CACHE_MAX_AGE_MS

    ) {

      window.sessionStorage.removeItem(

        cacheKey

      );



      return null;

    }





    /*

 * Successful referral / once-off access keeps the

 * existing one-check-per-session behaviour.

 *

 * Partner-sponsored access is revalidated

 * periodically and also respects its absolute

 * cacheExpiresAt boundary when supplied.

 */

    return access;

  } catch (error) {

    console.warn(

      "Could not read paid journey access cache:",

      error

    );



    return null;

  }

}





/*

 * Allows RequireSubscription to inspect the

 * existing session result synchronously.

 *

 * This prevents another "Checking access"

 * screen after the dashboard has already

 * checked L10+ access.

 */

export function getCachedPaidJourneyAccessForUser(

  userId

) {

  return readPaidJourneyAccessSessionCache(

    userId

  );

}





export function writePaidJourneyAccessSessionCache(

  userId,

  access

) {

  try {

    if (

      typeof window ===

      "undefined"

    ) {

      return;

    }





    if (

      !access ||

      typeof access !==

        "object"

    ) {

      return;

    }





    const cacheKey =

      makeAccessCacheKey(

        userId

      );





    if (!cacheKey) {

      return;

    }





    /*

     * Never deliberately write an already-expired

     * access result into the session cache.

     */

    const hardExpiryMs =

      getAccessHardExpiryMs(

        access

      );





    if (

      hardExpiryMs !== null &&

      Date.now() >=

        hardExpiryMs

    ) {

      window.sessionStorage.removeItem(

        cacheKey

      );



      return;

    }





    window.sessionStorage.setItem(

      cacheKey,

      JSON.stringify({

        savedAt:

          Date.now(),



        access,

      })

    );

  } catch (error) {

    console.warn(

      "Could not save paid journey access cache:",

      error

    );

  }

}





export function clearPaidJourneyAccessSessionCache(

  userId = null

) {

  try {

    if (

      typeof window ===

      "undefined"

    ) {

      return;

    }





    if (userId) {

      const cacheKey =

        makeAccessCacheKey(

          userId

        );





      if (cacheKey) {

        window.sessionStorage.removeItem(

          cacheKey

        );

      }



      return;

    }





    Object.keys(

      window.sessionStorage

    ).forEach(

      (key) => {

        if (

          key.startsWith(

            ACCESS_CACHE_PREFIX

          )

        ) {

          window.sessionStorage.removeItem(

            key

          );

        }

      }

    );

  } catch (error) {

    console.warn(

      "Could not clear paid journey access cache:",

      error

    );

  }

}





/* -------------------------------------------------------------------------- */

/* Auth                                                                       */

/* -------------------------------------------------------------------------- */



async function getCurrentSessionUserId() {

  try {

    /*

     * getSession() uses the existing local

     * Supabase session instead of forcing

     * another user verification request.

     */

    const {

      data,

      error,

    } =

      await supabase.auth.getSession();





    if (error) {

      console.warn(

        "Could not read the current auth session:",

        error

      );



      return null;

    }





    return (

      data

        ?.session

        ?.user

        ?.id ||

      null

    );

  } catch (error) {

    console.warn(

      "Could not read the current auth session:",

      error

    );



    return null;

  }

}





/* -------------------------------------------------------------------------- */

/* Individual access sources                                                  */

/* -------------------------------------------------------------------------- */



async function getReferralAccessSafe() {
  try {
    return await getReferralMonthAccess(supabase);
  } catch (error) {
    console.warn("Could not check referral month access:", error);
    return { active: false };
  }
}

async function getSubscriptionAccessSafe() {
  try {
    return await getMySubscriptionStatus();
  } catch (error) {
    console.warn("Could not check subscription access:", error);
    return { hasSubscriptionAccess: false };
  }
}

async function getTrialStatusSafe() {
  try {
    const { data, error } = await supabase.rpc("get_my_gwin_trial_status");
    if (error) throw error;
    return data || { eligible: false, reason: "trial_unavailable" };
  } catch (error) {
    console.warn("Could not check free-trial access:", error);
    return { eligible: false, reason: "trial_unavailable" };
  }
}

async function getPartnerSponsoredAccessSafe() {
  try {
    return await getPartnerSponsoredPaidJourneyResult();
  } catch (error) {
    console.warn("Could not check Partner-sponsored journey access:", error);
    return null;
  }
}

/* -------------------------------------------------------------------------- */

/* Main paid journey access check                                             */

/* -------------------------------------------------------------------------- */



export async function checkPaidJourneyAccessForCurrentUser({
  questId,
  levelNumber,
  userId = null,
  forceRefresh = false,
} = {}) {
  const questNumber = toNumber(questId);
  const normalizedLevelNumber = toNumber(levelNumber);

  if (!questNumber) {
    return {
      allowed: false,
      reason: "invalid_quest",
      showPayment: false,
      questNumber: null,
      levelNumber: normalizedLevelNumber,
      message: "We could not determine which quest you are trying to open.",
    };
  }

  const resolvedUserId = userId || (await getCurrentSessionUserId());
  if (!resolvedUserId) {
    return {
      allowed: false,
      reason: "not_authenticated",
      showPayment: false,
      questNumber,
      levelNumber: normalizedLevelNumber,
      message: "Please sign in again to continue.",
    };
  }

  if (!forceRefresh) {
    const cachedAccess = readPaidJourneyAccessSessionCache(resolvedUserId);
    if (cachedAccess) {
      return { ...cachedAccess, questNumber, levelNumber: normalizedLevelNumber };
    }
  }

  const [partnerSponsoredAccess, subscriptionAccess, referralAccess, trialStatus] =
    await Promise.all([
      getPartnerSponsoredAccessSafe(),
      getSubscriptionAccessSafe(),
      getReferralAccessSafe(),
      getTrialStatusSafe(),
    ]);

  let result;

  if (partnerSponsoredAccess?.allowed === true) {
    result = {
      ...partnerSponsoredAccess,
      allowed: true,
      reason: "partner_sponsored_access",
      showPayment: false,
      questNumber,
      levelNumber: normalizedLevelNumber,
      title: "Partner-sponsored journey unlocked",
      message: partnerSponsoredAccess?.cohortName
        ? `Your learning journey is sponsored through ${partnerSponsoredAccess.cohortName}.`
        : "Your learning journey is currently sponsored through a Partner programme.",
    };
  } else if (subscriptionAccess?.hasSubscriptionAccess === true) {
    result = {
      allowed: true,
      reason: "subscription_access",
      showPayment: false,
      questNumber,
      levelNumber: normalizedLevelNumber,
      accessEndsAt: subscriptionAccess.accessEndsAt || null,
      cacheExpiresAt: subscriptionAccess.accessEndsAt || null,
      title: "Subscription active",
      message: "Your Gwin subscription is active.",
    };
  } else if (referralAccess?.active === true) {
    result = {
      allowed: true,
      reason: "referral_month_access",
      showPayment: false,
      questNumber,
      levelNumber: normalizedLevelNumber,
      accessEndsAt: referralAccess.expiresAt || null,
      cacheExpiresAt: referralAccess.expiresAt || null,
      title: "Referral reward active",
      message: "Your free month of Gwin access is active.",
    };
  } else if (trialStatus?.eligible === true) {
    result = {
      allowed: true,
      reason: "free_trial",
      showPayment: false,
      questNumber,
      levelNumber: normalizedLevelNumber,
      trialEndsAt: trialStatus.trial_ends_at || null,
      trialCompletedLevels: Number(trialStatus.completed_levels || 0),
      trialLevelLimit: Number(trialStatus.level_limit || 6),
      cacheExpiresAt: trialStatus.trial_ends_at || null,
      title: "Free trial active",
      message: "Your 14-day Gwin free trial is active.",
    };
  } else {
    const trialReason = String(trialStatus?.reason || "");
    const message =
      trialReason === "partner_history"
        ? "Your sponsored cohort access has ended. Subscribe to continue your Gwin journey."
        : trialReason === "trial_level_limit_reached"
        ? "You’ve completed the 6 levels included in your free trial. Subscribe to continue your Gwin journey."
        : trialReason === "trial_expired"
        ? "Your 14-day free trial has ended. Subscribe to continue your Gwin journey."
        : "Subscribe to continue your Gwin journey.";

    result = {
      allowed: false,
      reason: "subscription_required",
      trialReason: trialReason || null,
      showPayment: true,
      questNumber,
      levelNumber: normalizedLevelNumber,
      title: "Continue with Gwin",
      message,
    };
  }

  // Trial access is intentionally not session-cached because the completed-level
  // count changes during the session. Re-checking prevents Level 7 from opening
  // after the learner completes the 6th trial level.
  if (result.reason === "free_trial") {
    clearPaidJourneyAccessSessionCache(resolvedUserId);
  } else {
    writePaidJourneyAccessSessionCache(resolvedUserId, result);
  }

  return result;
}
